import { useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';

/**
 * Hook for managing multiple filter items
 * Each filter item has: { id, columnField, operatorValue, value }
 */
export const useMultiFilter = () => {
  const [filterItems, setFilterItems] = useState([]);

  const addFilter = useCallback(() => {
    const newFilter = {
      id: uuidv4(),
      columnField: '',
      operatorValue: 'contains',
      value: ''
    };
    setFilterItems((prev) => [...prev, newFilter]);
  }, []);

  const removeFilter = useCallback((filterId) => {
    setFilterItems((prev) => prev.filter((item) => item.id !== filterId));
  }, []);

  const updateFilter = useCallback((filterId, updates) => {
    setFilterItems((prev) =>
      prev.map((item) =>
        item.id === filterId ? { ...item, ...updates } : item
      )
    );
  }, []);

  const clearAllFilters = useCallback(() => {
    setFilterItems([]);
  }, []);

  return {
    filterItems,
    addFilter,
    removeFilter,
    updateFilter,
    clearAllFilters
  };
};
